export default __webpack_public_path__ + "static/media/sale-week.49af015c.svg";